import { createAsyncThunk } from "@reduxjs/toolkit";
import { IOffer } from "../offerModel";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllOffers = createAsyncThunk("Offer/FindAllOffer", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Offer/FindAllOffer`,
      { Title: "" },
    );
    return response.data?.Data;
  } catch (error: any) {
    console.error("Error Fetching Offer:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createOffer = createAsyncThunk(
  "Offer/InsertOffer",
  async (offerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Offer/InsertOffer`,
        offerData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Offer:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateOffer = createAsyncThunk(
  "Offer/UpdateOffer",
  async (offerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Offer/UpdateOffer`,
        offerData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Offer:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteOffer = createAsyncThunk(
  "Offer/DeleteOffer",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Offer/DeleteOffer`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Offer :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getOfferByID = createAsyncThunk(
  "Offer/FindByIDOffer",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Offer/FindByIDOffer`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        Images: result.Images ?? "",
        IsActive: result.IsActive ? 1 : 2,
      } as IOffer;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Offer :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveOffer = createAsyncThunk(
  "Offer/ActiveInactiveOffer",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Offer/ActiveInactiveOffer`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Offer :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const OfferImageUpload = createAsyncThunk(
  "Offer/OfferImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Offer/OfferImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Offer Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
